import { render, staticRenderFns } from "./SalesBarChart.vue?vue&type=template&id=9ed7e9ae"
import script from "./SalesBarChart.vue?vue&type=script&lang=js"
export * from "./SalesBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports